// Shared with chalice-experience

const checksum = s => {
  let chk = 0x12345678;
  const len = s.length;
  for (let i = 0; i < len; i++) {
    chk += s.charCodeAt(i) * (i + 1);
  }

  return (chk & 0xffffffff).toString(16);
};

const secret = 'function(r){return _n(r,e,t)}';

export default payload => {
  // Order of the keys is not guaranteed
  const keys = Object.keys(payload).sort();
  const stringified = keys.reduce(
    (memo, key) => `${memo}&${key}=${payload[key]}`,
    ''
  );
  return checksum(stringified + secret);
};
